import { Box, Grid } from '@mui/material';
import {
  CatalogList,
  useCatalogListData,
} from '@/packages/courses/components/catalog-list';
import { CatalogFiltersList } from '@/packages/courses/components/filters';
import { HeaderTitle } from '@/packages/courses/components/header-title';

export const CatalogFiltersDesktop = () => {
  const { totalCount, isFetching } = useCatalogListData();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 4, lg: 3 }}>
        <Box mb={2}>
          <HeaderTitle loading={isFetching} totalCount={totalCount} />
        </Box>
        <CatalogFiltersList />
      </Grid>
      <Grid size={{ xs: 12, md: 8, lg: 9 }}>
        <CatalogList />
      </Grid>
    </Grid>
  );
};
